module.exports = __webpack_public_path__ + "img/pool-view.fa8206df.jpg";